import { render, staticRenderFns } from "./ed-splash-screen.component.vue?vue&type=template&id=933a1f52&scoped=true&"
import script from "./ed-splash-screen.component.ts?vue&type=script&lang=ts&"
export * from "./ed-splash-screen.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-splash-screen.component.scss?vue&type=style&index=0&id=933a1f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933a1f52",
  null
  
)

export default component.exports